export const updateUrlVersion = (url, version) => url.replace(/\/v\d+\//, `/v${version}/`);
